import { ConfigOption } from '@ngx-formly/core';
import { WidgetAssetPreviewComponent } from './widget-asset-preview/widget-asset-preview.component';

export const ASSET_FORMLY_TYPES: ConfigOption['types'] = [
  { name: 'formly-asset-preview', component: WidgetAssetPreviewComponent, },

];
